<template>
  <div class="data_body">
    <div style="width: 100%; height: 100%">
      <div
        id="charts_canvas"
        class="echart"
        style="width: 100%; height: 100%"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    monthArray: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      chartObj: null,
      ooption: {
        xdata: [],
        course: [],
      },
      option: {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
          minInterval: 1
        },
        grid: {
          top: "10%",
          left: "5%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        },
        series: [
          {
            // data: [820, 932, 901, 934, 1290, 1330, 1320],
            data: [],
            type: "line",
            areaStyle: {},
            itemStyle: {
              normal: {
                color: function (params) {
                  return "#106bff";
                },
              },
            },
          },
        ],
      },
    };
  },
  methods: {
    setChart(option) {
      // 雷达图显示的标签
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        const chartObj = this.$echarts.init(
          this.$el.querySelector("#charts_canvas")
        );
        this.option.xAxis.data = option.xdata;
        this.option.series[0].data = option.course;
        // 初始化雷达图
        this.chartObj = chartObj;
        this.chartObj.setOption(this.option);
      });
    },
    setJson(array) {
      this.ooption = {
        xdata: [],
        course: [],
      }
      let _array = array
      for (var i = 0; i < _array.length; i++) {
        this.ooption.xdata.push(_array[i].Month + '月')
        this.ooption.course.push(_array[i].course)
      }

      if (!this.chartObj) {
        this.setChart(this.ooption);
      } else {
        this.option.xAxis.data = this.ooption.xdata;
        this.option.series[0].data = this.ooption.course;
        this.chartObj.setOption(this.option);
      }
    }
  },
  watch: {
    monthArray: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setJson(newValue)
        this.$forceUpdate();
      },
    },
  },
  mounted() {
    this.setJson(this.monthArray)

    var _this = this;
    window.addEventListener("resize", () => {
      if (_this.chartObj) {
        _this.chartObj.resize();
      }
    });
  },
};
</script>

<style scoped>
.data_body {
  height: 100%;
  /* display: flex; */
  position: relative;
  border-radius: 5px;
  /* border: 1px solid #eee; */
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
  width: 95%;
  /* background: #fff; */
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dataBoardNew/course/chartList/teaFre.vue